import React, { useEffect } from 'react'
import { Col, Row } from 'antd'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const settingLinks = [
	{
		name: 'Account',
		href: '/teacher/dashboard/settings/account'
	},
	{
		name: 'Billing',
		href: '/teacher/dashboard/settings/billing'
	},
	{
		name: 'Security',
		href: '/teacher/dashboard/settings/security'
	},
]

const Teachersettings = () => {
	const navigate = useNavigate()
	const { pathname } = useLocation()

	useEffect(() => {
		navigate(`${pathname}`, {
			state: {
				pageName: 'Settings'
			}
		})

		// eslint-disable-next-line
	}, [])


	return (
		<div className={`pr-10 mt-4 mb-10 min-h-screen h-full`}>
			<Row gutter={16}>
				<Col xs={24} md={24} lg={4}>
					<div className='flex flex-col w-full'>
						{
							settingLinks.map((item) => (
								<a href={item.href}
									key={`profile-nav-${item.name}`}
									rel="noopener noreferrer"
									onClick={(e) => {
										e.preventDefault()
										navigate(item.href, {
											state: {
												pageName: 'Settings'
											}
										})
									}}
									className={`${pathname === item.href ? 'bg-appcolorpurplefaint font-semibold ' : ''} 
                    hover:bg-appcolorpurplefaint hover:font-semibold 
                    text-appcolorblack text-base py-5 px-6 w-full rounded-[10px] mb-4`}
								>
									{item.name}
								</a>
							))
						}
					</div>
				</Col>
				<Col xs={24} md={24} lg={20}>
					<Outlet />
				</Col>
			</Row>
		</div>
	)
}

export default Teachersettings